export const REQUIRED_VALIDATOR_KEY = 'required';
export const MIN_LENGTH_VALIDATOR_KEY = 'minLength';
export const MAX_LENGTH_VALIDATOR_KEY = 'maxLength';
export const REQUIRED_TRUE_VALIDATOR_KEY = 'requiredTrue';
export const MIN_VALIDATOR_KEY = 'min';
export const MAX_VALIDATOR_KEY = 'max';
export const EMAIL_VALIDATOR_KEY = 'email';
export const PATTERN_VALIDATOR_KEY = 'pattern';
export const NULL_VALIDATOR_KEY = 'nullValidator';
export const MIN_CHECKED_KEY = 'minChecked';
export const PASSWORD_KEY = 'password';
export const EVAL_REQUIRED_VALIDATOR_KEY = 'evalRequired';

export const ANGULAR_NATIVE_VALIDATORS_KEY: string[] = [
  REQUIRED_VALIDATOR_KEY,
  MIN_LENGTH_VALIDATOR_KEY,
  MAX_LENGTH_VALIDATOR_KEY,
  REQUIRED_TRUE_VALIDATOR_KEY,
  MIN_VALIDATOR_KEY,
  MAX_VALIDATOR_KEY,
  EMAIL_VALIDATOR_KEY,
  PATTERN_VALIDATOR_KEY,
  NULL_VALIDATOR_KEY,
  MIN_CHECKED_KEY,
  PASSWORD_KEY
];
